import serverCall from "../serverCall";

const getUserDetails = () => {
  try {
    const response = serverCall.get(`/users/user-profile`);
    return response;
  } catch (error) {
    throw error;
  }
};

const UserService = {
  getUserDetails,
};

export default UserService;
